/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Connected_And_VerifiedInputs */

const en_connected_and_verified = /** @type {(inputs: Connected_And_VerifiedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Connected & Verified`)
};

const es_connected_and_verified = /** @type {(inputs: Connected_And_VerifiedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Conectada y Verificada`)
};

const fr_connected_and_verified = /** @type {(inputs: Connected_And_VerifiedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Connecté et Vérifié`)
};

const de_connected_and_verified = /** @type {(inputs: Connected_And_VerifiedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Verbunden & Verifiziert`)
};

const ja_connected_and_verified = /** @type {(inputs: Connected_And_VerifiedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`接続および確認済み`)
};

const zh_connected_and_verified = /** @type {(inputs: Connected_And_VerifiedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`已连接 & 已验证`)
};

const ar_connected_and_verified = /** @type {(inputs: Connected_And_VerifiedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`متصل وموثق`)
};

const id_connected_and_verified = /** @type {(inputs: Connected_And_VerifiedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Terhubung & Terverifikasi`)
};

const it_connected_and_verified = /** @type {(inputs: Connected_And_VerifiedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Connesso & Verificato`)
};

const ru_connected_and_verified = /** @type {(inputs: Connected_And_VerifiedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Подключен и подтвержден`)
};

const pt_connected_and_verified = /** @type {(inputs: Connected_And_VerifiedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Conectada e Verificada`)
};

const ko_connected_and_verified = /** @type {(inputs: Connected_And_VerifiedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`연결됨 및 검증됨`)
};

/**
* | output |
* | --- |
* | "Connected & Verified" |
*
* @param {Connected_And_VerifiedInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const connected_and_verified = /** @type {((inputs?: Connected_And_VerifiedInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Connected_And_VerifiedInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_connected_and_verified(inputs)
	if (locale === "es") return es_connected_and_verified(inputs)
	if (locale === "fr") return fr_connected_and_verified(inputs)
	if (locale === "de") return de_connected_and_verified(inputs)
	if (locale === "ja") return ja_connected_and_verified(inputs)
	if (locale === "zh") return zh_connected_and_verified(inputs)
	if (locale === "ar") return ar_connected_and_verified(inputs)
	if (locale === "id") return id_connected_and_verified(inputs)
	if (locale === "it") return it_connected_and_verified(inputs)
	if (locale === "ru") return ru_connected_and_verified(inputs)
	if (locale === "pt") return pt_connected_and_verified(inputs)
	return ko_connected_and_verified(inputs)
});